import { readable, writable } from "svelte/store";
export class Geolocation {
    constructor() {
        this._coords = writable(null);
        this._isDenied = writable(false);
        this.observers = new Set();
        this.lastPositon = null;
        this.watchId = null;
        this.numSubscriptors = 0;
        this.isOverride = false;
        this.isWatching = false;
        this.coords = readable(null, set => {
            this.numSubscriptors++;
            const unsubscribe = this._coords.subscribe(set);
            this.startWatch();
            return () => {
                this.numSubscriptors--;
                this.stopWatch();
                unsubscribe();
            };
        });
        this.isDenied = readable(false, set => this._isDenied.subscribe(set));
    }
    getPosition(force = false) {
        return new Promise((resolve, reject) => {
            if (!force && this.lastPositon) {
                resolve(this.lastPositon);
                return;
            }
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({
                    lon: position.coords.longitude,
                    lat: position.coords.latitude,
                });
                this.successHandler(position);
            }, error => {
                this.failHandler(error);
                reject(error);
            }, {
                timeout: 5000,
                enableHighAccuracy: true,
            });
        });
    }
    subscribe(fn) {
        if (!this.observers.has(fn)) {
            this.numSubscriptors++;
            if (this.lastPositon) {
                fn(this.lastPositon);
            }
            this.observers.add(fn);
            this.startWatch();
        }
        return () => this.unsubscribe(fn);
    }
    unsubscribe(fn) {
        this.numSubscriptors--;
        this.observers.delete(fn);
        this.stopWatch();
    }
    override(coordinates) {
        this.isOverride = true;
        this.stopWatch();
        this.lastPositon = coordinates;
        this.notifyObservers();
    }
    startWatch() {
        if (this.isWatching || this.isOverride || this.numSubscriptors === 0) {
            return;
        }
        this.isWatching = true;
        this.watchId = window.navigator.geolocation.watchPosition(position => this.successHandler(position), error => this.failHandler(error));
    }
    stopWatch() {
        if (!this.isWatching || (!this.isOverride && this.numSubscriptors !== 0)) {
            return;
        }
        this.isWatching = false;
        window.navigator.geolocation.clearWatch(this.watchId);
        this.watchId = null;
    }
    successHandler(position) {
        this.lastPositon = {
            lon: position.coords.longitude,
            lat: position.coords.latitude,
        };
        this.notifyObservers();
    }
    failHandler(error) {
        console.error(error);
        this._isDenied.set(error.code === error.PERMISSION_DENIED);
    }
    notifyObservers() {
        this._coords.set(this.lastPositon);
        for (const observer of this.observers) {
            observer(this.lastPositon);
        }
    }
}
;
